import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import type { IResourceModel } from '@/shared/model/briefing-widget.model';
import moment from 'moment';
import { isNullish } from '@/util/ds-util';
import ResourceFooterComponent from '@/shared/cards/briefing/resource/components/resource-footer/resource-footer.vue';
import { formatDateAgo } from '@/util/date-util';
import { getFaviconByUrl } from '@/util/common-util';

@Component({
  components: {
    'resource-footer': ResourceFooterComponent,
  },
  methods: { getFaviconByUrl, isNullish, formatDateAgo },
  computed: {
    moment() {
      return moment;
    },
  },
})
export default class FileWidgetComponent extends Vue {
  @Prop(Object) readonly formModel: IResourceModel;
  @Prop(Boolean) readonly isHideOptions: boolean;
  @Prop(Boolean) readonly isHideAddReference: boolean;
  @Prop(Boolean) readonly isHideHidden: boolean;
  @Prop(Boolean) readonly isHideShared: boolean;
  @Prop(Boolean) readonly isHideGoover: boolean;

  @Emit('share') share() {}

  @Emit('hide') hide() {}

  @Emit('select-user-social') selectUserSocial() {}

  @Emit('view-detail') viewDetail() {}

  @Emit('toggle-resource') toggleResource() {}

  @Emit('add-to-reference') addToReference() {}

  @Emit('goover') goover() {}

  mounted() {}

  get fileType() {
    if (this.formModel.title.endsWith('.pdf')) return 'PDF';
    if (this.formModel.title.endsWith('.doc') || this.formModel.title.endsWith('.docx') || this.formModel.title.endsWith('.odt'))
      return 'DOC';
    if (this.formModel.title.endsWith('.ppt') || this.formModel.title.endsWith('.pptx')) return 'PPT';
    if (this.formModel.title.endsWith('.xls') || this.formModel.title.endsWith('.xlsx') || this.formModel.title.endsWith('.csv'))
      return 'EXCEL';
    return 'TEXT';
  }

  get favicon() {
    if (this.formModel.originParentDocDetail.datasource_channel_type) {
      switch (this.formModel.originParentDocDetail.datasource_channel_type[0]) {
        case 'DROP_BOX':
          return 'https://www.google.com/s2/favicons?sz=64&domain=dropbox.com';
        case 'GOOGLE_DRIVE':
          return 'https://drive.google.com/favicon.ico';
        case 'ONE_DRIVE':
          return 'https://onedrive.live.com/favicon.ico';
      }
    }
    return `https://www.google.com/s2/favicons?domain=${this.formModel.url}`;
  }
}
